import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    centralize: {
      textAlign: 'center',
      fontSize: 12,
    },
    header: {
      padding: '0px !important',
    },

    iconSize: {
      fontSize: 12,
      color: palette.white,
    },
    iconContainer: {
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      '& span': {
        height: 'auto',
        padding: '0px 3px',
        alignItems: 'center',
        borderRadius: '50%',
      },
    },

    patternSpan: {
      background: 'green',
    },

    inMaintenance: {
      fontSize: 15,
    },
    requested: {
      color: palette.deepBlue,
      fontSize: 15,
    },
    finished: {
      color: palette.status.success,
      fontSize: 15,
    },
    started: {
      color: palette.blue,
      fontSize: 15,
    },

    iconFormat: {
      background: palette.deepBlue,
      color: palette.white,
      borderRadius: '50%',
      padding: 6,
      transform: 'scale(.7)',
    },
    strong: {
      fontWeight: 'bold',
    },
    closeLogs: {
      margin: '16px 0 8px',
    },
    longField: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontSize: 12,
      color: palette.darkGray,
    },
    longUUIDField: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontSize: 12,
      color: palette.darkGray,
    },
    longNameField: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontSize: 12,
      color: palette.darkGray,
      maxWidth: 260,
    },
    centerFields: {
      textAlign: 'center',
      fontSize: 12,

      '& .MuiIconButton-root': {
        padding: 0,
      },
    },
    accessButton: {
      fontSize: 15,
      color: palette.blue,
    },
    accessButtonHeader: {
      width: 40,
      fontSize: 12,
      color: palette.darkGray,
    },

    dateField: {
      color: palette.darkGray,
      whiteSpace: 'nowrap',
    },
    summaryRowTable: {
      backgroundColor: `${palette.white} !important`,
      height: '20px !important',

      '& .MuiTableCell-root': {
        padding: 0,
      },
      '&:hover': {
        background: `${palette.superLightDeepBlue} !important`,
        cursor: 'default',
      },
    },
    envRow: {
      backgroundColor: `${palette.lightYellow} !important`,
      height: '20px !important',

      '& .MuiTableCell-root': {
        padding: 0,
      },
      '&:hover': {
        background: `${palette.superLightDeepBlue} !important`,
      },
    },
    envRowDirect: {
      height: '20px !important',

      '& .MuiTableCell-root': {
        padding: 0,
      },
      '&:hover': {
        background: `${palette.superLightDeepBlue} !important`,
        cursor: 'pointer',
      },
    },
  });
